module.exports = __webpack_public_path__ + "b927698e343a605f741d70b503b71c4e.png";